<template>
  <div>
    <v-card class="elevation-0">
      <v-data-table
        :headers="headers"
        :items="memberTestStepList"
        :sort-by="['stepNumber', 'substepNumber']"
        :sort-desc="[false, false]"
        hide-default-footer
        disable-pagination
        item-key="id"
      >
        <template v-slot:item="{ item }">
          <tr data-cy="memberTestStepList__item">
            <td>
              <router-link
                v-if="isUatOpen && hasTestPlanEdit"
                :to="
                  `/pack/${packId}/releaseNote/${releaseNoteId}/testStep/${item.id}/serviceArea/${serviceAreaId}/edit`
                "
              >
                {{ item.stepNumber }}{{ item.substepNumber ? `.${item.substepNumber}` : `` }}
              </router-link>
              <span v-else>{{ item.stepNumber }}{{ item.substepNumber ? `.${item.substepNumber}` : `` }}</span>
            </td>
            <td>
              <span v-html="item.scenario || '--'"></span>
            </td>
            <td>
              <span v-html="item.testingDetails || '--'"></span>
            </td>
            <td>
              <span v-html="item.expectedOutcome || '--'"></span>
            </td>
            <td>
              <span v-html="item.actualOutcome || '--'"></span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "memberTestStepList",
  components: {},
  computed: {
    memberTestStepList() {
      return this.$store.getters["testStep/memberTestStepList"](this.releaseNoteId);
    },
    packId() {
      return this.$route.params.packId;
    },
    ...mapGetters({
      isUatOpen: "pack/isUatOpen",
      hasTestPlanEdit: "session/hasTestPlanEdit",
    }),
  },

  async created() {
    try {
      await this.getMemberTestStepList(this.releaseNoteId, this.serviceAreaId);
    } catch (e) {
      console.error(e);
      this.$notifyError("Error loading test steps");
    }
  },
  data() {
    return {
      headers: [
        {
          text: "Step",
          align: "left",
          sortable: true,
          value: "stepNumber",
        },
        {
          text: "Scenario",
          align: "left",
          sortable: false,
          value: "scenario",
        },
        {
          text: "Testing Details",
          align: "left",
          sortable: false,
          value: "testingDetails",
        },
        {
          text: "Expected Outcome",
          align: "left",
          sortable: false,
          value: "expectedOutcome",
        },
        {
          text: "Actual Outcome",
          align: "left",
          sortable: false,
          value: "actualOutcome",
        },
      ],
      search: null,
    };
  },
  methods: {
    async getMemberTestStepList(releaseNoteId, serviceAreaId) {
      await this.$store.dispatch("testStep/memberList", {
        releaseNoteId,
        serviceAreaId,
      });
    },
  },
  props: ["releaseNoteId", "serviceAreaId"],
  watch: {
    async releaseNoteId(val) {
      await this.getMemberTestStepList(val, this.serviceAreaId);
    },
  },
};
</script>
